/**
 * Browser capability probes.
 *
 * We never *block* the user before they try to call — the failure UX is
 * far better when the EL SDK throws its own descriptive error. These
 * helpers exist for two reasons:
 *
 *   1. Hide the FAB on browsers where WebRTC will provably fail
 *      (legacy IE, file://, sandboxed iframes without `allow="microphone"`).
 *   2. Adjust the panel layout for narrow viewports (mobile takeover).
 */

export function isWebRTCSupported(): boolean {
  if (typeof window === "undefined") return false;
  return (
    typeof window.RTCPeerConnection !== "undefined" &&
    typeof navigator !== "undefined" &&
    typeof navigator.mediaDevices !== "undefined" &&
    typeof navigator.mediaDevices.getUserMedia === "function"
  );
}

export function isMobileViewport(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia("(max-width: 640px)").matches;
}

/**
 * Returns `true` only if the document is served over a secure context
 * (https://, localhost). WebRTC microphone access requires this.
 */
export function isSecureContext(): boolean {
  if (typeof window === "undefined") return false;
  return Boolean(window.isSecureContext);
}
